import Vue from 'vue';
import VueDOMPurifyHTML from 'vue-dompurify-html';

/**
 * A "safe" replacement for the v-html directive.
 * https://www.npmjs.com/package/vue-dompurify-html/v/2.6.0
 */
Vue.use(VueDOMPurifyHTML, {
  default: {
    ADD_ATTR: ['target'], // Разрешить атрибут target
    ADD_URI_SAFE_ATTR: ['target'], // Разрешить target в ссылках
  },
  hooks: {
    uponSanitizeElement: (node) => {
      if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
        // Устанавливаем атрибут rel, если его нет
        if (!node.getAttribute('rel')) {
          node.setAttribute('rel', 'noopener noreferrer');
        }
      }
    },
  },
});
